module.exports = __webpack_public_path__ + "img/BlinkArt_Sword12_Red.4157c579.png";